export enum EventName {
    ADD_TO_LEVEL = 'ADD_TO_LEVEL',
    ADD_TO_UI = 'ADD_TO_UI',
    ADD_TO_BACKGROUND = 'ADD_TO_BACKGROUND',
    DRAG_CARD = 'DRAG_CARD',
    DRAG_DISABLED_CARD = 'DRAG_DISABLED_CARD',
    UNDO_TRIGGERED = 'UNDO',
    MOVE = 'MOVE',
    UNDO_MOVE = 'UNDO_MOVE',
    NEW_GAME = 'NEW_GAME',
    START_NEW_GAME = 'START_NEW_GAME',
    OPEN_SETTINGS = 'OPEN_SETTINGS',
    HIDE_SETTINGS = 'HIDE_SETTINGS',
    TOGGLE_SOUND = 'TOGGLE_SOUND',
    TOGGLE_AUTOCOMPLETE = 'TOGGLE_AUTOCOMPLETE',
    TOGGLE_LEFT_HANDED = 'TOGGLE_LEFT_HANDED',
    ADD_SCORE = 'ADD_SCORE',
    SUBTRACT_SCORE = 'SUBTRACT_SCORE',
    REVEAL_CARD = 'REVEAL_CARD',
    UNDO_REVEAL_CARD = 'UNDO_REVEAL_CARD',
    CHANGE_CARD_BACK = 'CHANGE_CARD_BACK',
    CHANGE_BG = 'CHANGE_BG',
    CHANGE_CARD_FRONT = 'CHANGE_CARD_FRONT',
    CHANGE_LANGUAGE = 'CHANGE_LANGUAGE',
    WIN = 'WIN',
    ADD_TO_OVERLAY = 'ADD_TO_OVERLAY',
    HIDE_UI = 'HIDE_UI',
    SHOW_UI = 'SHOW_UI',
    HIDE_GAME = 'HIDE_GAME',
    SHOW_GAME = 'SHOW_GAME',
    REFRESH = 'REFRESH',
    RUN_AUTOCOMPLETE = 'RUN_AUTOCOMPLETE',
    AUTOCOMPLETE_COMPLETE = 'AUTOCOMPLETE_COMPLETE',
    AUTOCOMPLETE_MOVE_FINISHED = 'AUTOCOMPLETE_MOVE_FINISHED',
    AUTOPLAY_MOVE_FINISHED = 'AUTOPLAY_MOVE_FINISHED',

    HIDE_LOADER = 'HIDE_LOADER',
    SHOW_LOADER = 'SHOW_LOADER',
    DESIGN_ASSET_SET = 'DESIGN_ASSET_SET',
    GAME_READY = 'GAME_READY',
    BACKGROUND_LOADED = 'BACKGROUND_LOADED',
    RESET_GAME = 'RESET_GAME',
    UPDATE_STATISTICS = 'UPDATE_STATISTICS',
    AUTO_PLAY = 'AUTO_MOVE_CARD',
    TOGGLE_CARD_HIGHLIGHTING = 'TOGGLE_CARD_HIGHLIGHTING',
    DEAL_STOCKPILE = 'DEAL_STOCKPILE',
    BLOCK_ACTION_BUTTONS = 'BLOCK_MOVES',
    BACKGROUND_CLICKED = 'BACKGROUND_CLICKED',
    TOGGLE_AUTOPLAY = 'TOGGLE_AUTOPLAY',
    OPEN_DESIGN = 'OPEN_DESIGN',
    ON_VISIBILITY_CHANGE = 'ON_VISIBILITY_CHANGE',
    FACEBOOK_MODAL_HIDE = 'FACEBOOK_MODAL_HIDE',
    CTR_Z = 'CTR_Z',
    HINT = 'HINT_BUTTON_CLICKED',
    GAME_INTRO_COMPLETED = 'GAME_INTRO_COMPLETED',
    SHOW_ADS = 'SHOW_ADS',
    ADS_GRANTED = 'ADS_GRANTED',
    ADS_CLOSED = 'ADS_CLOSED',
    HINT_SHOW = 'HINT_SHOW',
    MAGIC_WAND = 'MAGIC_WAND',
    WAND_SHOW = 'WAND_SHOW',
    CLOSE_MODAL = 'CLOSE_MODAL',
    OPEN_MODAL = 'OPEN_MODAL',

    FADE_UI = 'FADE_UI',
    NO_MAGIC_KING_INFO = 'NO_MAGIC_KING_INFO',
    BLOCK_MAGIC_WAND = 'BLOCK_MAGIC_WAND',
    BLOCK_KEYBOARD = 'BLOCK_KEYBOARD',
    UNBLOCK_KEYBOARD = 'UNBLOCK_KEYBOARD',
    SHOW_WIN_AFTER_FEEDBACK = 'SHOW_WIN_AFTER_FEEDBACK',
    UI_ASSETS_LOADED = 'UI_ASSETS_LOADED',
    ADS_READY = 'ADS_READY',
    START_TUTORIAL = 'START_TUTORIAL',
    STOP_TUTORIAL = 'STOP_TUTORIAL',
    RESTART_TUTORIAL = 'RESTART_TUTORIAL',

    TUTORIAL_EXTERNAL_VALID_MOVE = 'TUTORIAL_EXTERNAL_VALID_MOVE',
    TUTORIAL_READY = 'TUTORIAL_READY',
    SAVE_GAME_STATE = "SAVE_GAME_STATE",

    UPDATE_HINT_BUTTON = 'UPDATE_HINT_BUTTON',

    SET_UNDO_DISABLED = 'SET_UNDO_DISABLED',
    SET_HINT_DISABLED = 'SET_HINT_DISABLED',
    SET_WAND_DISABLED = 'SET_WAND_DISABLED',

    BLOCK_WAND_AND_HINTS = 'BLOCK_WAND_AND_HINTS',
}
